module.exports = __webpack_public_path__ + "static/media/fundo2.b3eff68b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/assets/fundo2.png
 ** module id = 161
 ** module chunks = 0
 **/